'use client'

import { NewsFavicon } from '@/components/NewsFavicon'
import { useState } from 'react'
import SourcesLightbox from './SourcesLightbox'

export default function SourceImageGrid({ sources = [] }) {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)

  // Filter to sources with images and sort by date
  const sourcesWithImages = sources
    .filter((source) => source.image)
    .sort((a, b) => new Date(b.published_date) - new Date(a.published_date))

  // Show 4 images in 2x2 grid
  const displayImages = sourcesWithImages.slice(0, 4)
  const remainingCount = sources.length - 4

  if (sources.length === 0) return null

  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        {displayImages.map((source, i) => {
          const isLast = i === 3 && remainingCount > 0

          if (isLast) {
            return (
              <button
                key={source.id || i}
                onClick={() => setIsLightboxOpen(true)}
                className="relative group overflow-hidden rounded-sm bg-muted aspect-[4/3]"
              >
                <img
                  src={source.image}
                  alt={source.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60 group-hover:bg-black/70 transition-colors flex items-center justify-center">
                  <span className="text-white font-sans text-sm font-semibold">
                    +{remainingCount} more
                  </span>
                </div>
              </button>
            )
          }

          return (
            <a
              key={source.id || i}
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group overflow-hidden rounded-sm bg-muted aspect-[4/3]"
            >
              <img
                src={source.image}
                alt={source.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              {/* Gradient overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

              {/* Outlet badge */}
              <div className="absolute bottom-2 left-2">
                <NewsFavicon
                  src={`${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/public_assets/news-favicons/${source.outlet?.slug}.jpg`}
                  alt={source.outlet?.name}
                  faviconSize="sm"
                />
              </div>

              {/* Title on hover */}
              <div className="absolute inset-0 p-2 flex flex-col justify-end opacity-0 group-hover:opacity-100 transition-opacity">
                <p className="text-white text-xs font-medium leading-snug line-clamp-2">
                  {source.title}
                </p>
              </div>
            </a>
          )
        })}
      </div>

      <SourcesLightbox
        isOpen={isLightboxOpen}
        onClose={() => setIsLightboxOpen(false)}
        sources={sources}
      />
    </>
  )
}
